import { css } from 'styled-components';
import { FlexProps, GridProps } from 'theme/_mixins/entities/props';

export const _flex = (props?: FlexProps) => css`
  display: flex;
  align-items: ${props?.align || 'stretch'};
  justify-content: ${props?.justify || 'flex-start'};
  flex-direction: ${props?.direction || 'row'};
`;

export const _grid = (props?: GridProps) => css`
  display: grid;
  grid-template-columns: ${`repeat(${props?.columns || 1}, 1fr)`};
  grid-gap: ${props?.gap || 0}px;
`;

export const _ellipsis = () => css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
